import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=e7b8a0d4&scoped=true&lang=pug&"
import script from "./Follow.vue?vue&type=script&lang=js&"
export * from "./Follow.vue?vue&type=script&lang=js&"
import style0 from "./Follow.scss?vue&type=style&index=0&id=e7b8a0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b8a0d4",
  null
  
)

export default component.exports